import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Header from '../Header'
import FeedbackNav from '../FeedbackNav'
import FeedbackForm from '../FeedbackForm'
import HelpIconLink from '../HelpIconLink'
import classnames from 'classnames'
import { TOPIC_USING_BOARDS } from '../../constants/boardsHelpTopics'

import './CoreLayout.scss'
import '../../styles/core.scss'

class CoreLayout extends PureComponent {
  UNSAFE_componentWillMount() {
    this.props.loadConfig()
  }

  render() {
    const {userInfo, children, localize} = this.props
    const coreLayoutClasses = classnames({
      'core-layout': true,
      'impersonation-session': userInfo.isImpersonation,
    })

    return (
      <div className={coreLayoutClasses}>
        <Header userInfo={userInfo} localize={localize}>
          <FeedbackNav />
          <HelpIconLink helpTopic={TOPIC_USING_BOARDS}/>
        </Header>
        <FeedbackForm />
        <div className='core-layout__viewport'>
          {children}
        </div>
      </div>
    )
  }
}

CoreLayout.propTypes = {
  children : PropTypes.element.isRequired,
  loadConfig: PropTypes.func.isRequired,
  userInfo: PropTypes.object,
  localize: PropTypes.func,
}

export default CoreLayout



// WEBPACK FOOTER //
// ./src/components/CoreLayout/CoreLayout.js